import { Link } from "react-router-dom";
import { categories } from "@/utils/video";

const entries = [
  {
    ...categories[0],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20concept%20with%20a%20glowing%20film%20reel%20and%20dramatic%20orange%20spotlight%20beams%20on%20a%20dark%20stage%2C%20artistic%20minimal%20composition%2C%20warm%20highlights%20against%20deep%20dark%20background%2C%20high%20detail&width=600&height=400&seq=v91-cat-movie&orientation=landscape",
  },
  {
    ...categories[1],
    image:
      "https://readdy.ai/api/search-image?query=Modern%20television%20series%20concept%20with%20a%20stylized%20glowing%20screen%20frame%20and%20warm%20amber%20light%20ribbons%20floating%20in%20darkness%2C%20artistic%20minimal%20composition%2C%20warm%20highlights%20against%20deep%20dark%20background%2C%20high%20detail&width=600&height=400&seq=v91-cat-tv&orientation=landscape",
  },
  {
    ...categories[2],
    image:
      "https://readdy.ai/api/search-image?query=Variety%20show%20stage%20concept%20with%20a%20glowing%20microphone%20surrounded%20by%20colorful%20warm%20spotlights%20and%20confetti%2C%20artistic%20minimal%20composition%2C%20orange%20and%20gold%20highlights%20against%20deep%20dark%20background%2C%20high%20detail&width=600&height=400&seq=v91-cat-variety&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            频道分类
          </h2>
          <p className="mt-1 text-sm text-foreground-600">选择你感兴趣的频道，快速进入对应分类</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.key}
            to={`/category/${entry.key}`}
            className="group relative h-44 overflow-hidden rounded-lg border border-background-200/70 md:h-52"
          >
            <img
              src={entry.image}
              alt={`${entry.name}频道`}
              title={`${entry.name}频道在线观看`}
              className="absolute inset-0 h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5">
              <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${entry.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{entry.name}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-700">
                {entry.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}